import React from "react";
import { Link } from "react-router-dom"; // Importamos Link de react-router-dom

export default function SubUniversalMenuMobile({
  nombrePaginaSeleccionada = "",
  menuOpen,
  toggleMenu,
}) {
  return (
    <>
      <div
        data-figma-id="1337:14237"
        class="menu-hamburguesa"
        style={{
          transform: menuOpen ? "translate(0%)" : "translate(-100%)",
        }}
      >
        <div data-figma-id="1337:14204" class="frame-290020">
          <div data-figma-id="1337:14205" class="frame-290019">
            <div data-figma-id="1337:14222" class="boton-menu-hamburguesa">
              {/* Botón dentro del menú que lo cierra */}
              <i
                class="fi fi-ss-menu-burger menu-burger-3"
                onClick={toggleMenu}
              ></i>
            </div>
          </div>

          <div data-figma-id="1337:14207" class="menu-hamburguesa-apartados">
            <div data-figma-id="113:9431" class="menu-publico-apartados-mobile">
              <div
                data-figma-id="113:9514"
                className={`apartado-menu${
                  nombrePaginaSeleccionada === "Home" ? "" : "-2"
                }`}
              >
                <Link to="/" className="apartado-menu-texto">
                  Home
                </Link>
              </div>
            </div>

            {/* Cursos (Deja esto como está si no tiene ruta) */}
            <div
              data-figma-id="113:9514"
              className={`apartado-menu${
                nombrePaginaSeleccionada === "Cursos" ? "" : "-2"
              }`}
            >
              <Link to="/cursos" className="apartado-menu-texto">
                Cursos
              </Link>
            </div>

            {/* Link para Nosotros */}
            <div
              data-figma-id="113:9516"
              className={`apartado-menu${
                nombrePaginaSeleccionada === "Nosotros" ? "" : "-2"
              }`}
            >
              <Link to="/nosotros" className="apartado-menu-texto">
                Nosotros
              </Link>
            </div>
          </div>
        </div>
        <div data-figma-id="1337:14220" class="apartado-menu-3-copy">
          <p data-figma-id="1337:14221" class="apartado-menu-texto-2-copy">
            Solicitar Cuenta
          </p>
        </div>
      </div>
    </>
  );
}
